
import styles from '../style.module.css';
import thumb from 'assets/thumb.png';
import CustomVideo from './CustomVideo';
import React from "react";

export default function VideoSection({data}) {

    return (
        <div className = { styles.video_container }>
            <CustomVideo
                src = { '' }
                poster = { thumb }
            />
            <div
                className={styles.video_text}
                dangerouslySetInnerHTML={{
                    __html: data,
                }}
            />
        </div>
    )
}
